export default "__VITE_ASSET__DP7npecW__"